import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import type { SelectProps } from 'antd'
import { useGroupFee } from 'app/hooks/adminUsers/groupFee'

const ClassificationSelect = ({
	defaultValue,
	setSelectLevel,
	disabled,
}: any) => {
	const { data: list } = useGroupFee()
	const [options, setOptions] = useState<any>([])
	const [dvalue, setValue] = useState<any>({
		value: defaultValue,
		label: list?.filter((group: any) => group.level == defaultValue)[0]
			?.name,
	})
	useEffect(() => {
		if (list) {
			const newOptions = list?.map((group: any, index) => {
				if (group.level == defaultValue) {
					setSelectLevel(group.level)
					setValue({ value: group.level, label: group.name })
				}
				return {
					value: group.level,
					label: group.name,
				}
			})

			setOptions([{ value: '*', label: '전체' }, ...newOptions])
		}
	}, [list, defaultValue])

	const handleChange = (value: string[], label) => {
		setSelectLevel(value)
		setValue(label)
	}
	return (
		<Select
			placeholder="회원구분"
			value={dvalue}
			disabled={disabled}
			onChange={handleChange}
			filterOption={true}
			options={options}
			style={{ width: '100%' }}
		/>
	)
}

export default ClassificationSelect
